export enum MAIL_TEMPLATE_TYPE {
  WELCOME_EMAIL = 'WELCOME_EMAIL',
  PASSWORD_RESET_EMAIL = 'PASSWORD_RESET_EMAIL',
  PASSWORD_CHANGE_EMAIL = 'PASSWORD_CHANGE_EMAIL'
}
